import React from 'react';
import PropTypes from 'prop-types';

const AadhaarMasking = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.525 2.64H2.475C2.25634 2.6439 2.04058 2.69085 1.84007 2.77815C1.63955 2.86545 1.4582 2.9914 1.30637 3.1488C1.15454 3.3062 1.03521 3.49198 0.955184 3.69551C0.875162 3.89904 0.836021 4.11634 0.839997 4.335V13.665C0.836021 13.8837 0.875162 14.101 0.955184 14.3045C1.03521 14.508 1.15454 14.6938 1.30637 14.8512C1.4582 15.0086 1.63955 15.1345 1.84007 15.2219C2.04058 15.3092 2.25634 15.3561 2.475 15.36H15.525C15.7437 15.3561 15.9594 15.3092 16.1599 15.2219C16.3604 15.1345 16.5418 15.0086 16.6936 14.8512C16.8455 14.6938 16.9648 14.508 17.0448 14.3045C17.1248 14.101 17.164 13.8837 17.16 13.665V4.335C17.164 4.11634 17.1248 3.89904 17.0448 3.69551C16.9648 3.49198 16.8455 3.3062 16.6936 3.1488C16.5418 2.9914 16.3604 2.86545 16.1599 2.77815C15.9594 2.69085 15.7437 2.6439 15.525 2.64ZM15.525 13.665H2.475V4.335H15.525V13.665Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M10.4473 8H5.55268C4.69516 8 4 8.89119 4 9.99052V10.0095C4 11.1088 4.69516 12 5.55268 12H10.4473C11.3048 12 12 11.1088 12 10.0095V9.99052C12 8.89119 11.3048 8 10.4473 8Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

AadhaarMasking.propTypes = {
  fill: PropTypes.string,
};

export default AadhaarMasking;
